<template>
  <div class="wrapper">
    <base-bread-crumb :currBreadCrumb="currBreadCrumb"></base-bread-crumb>
    <div class="ccui-app-container">
      <!--高级搜索Begin-->
      <div class="ccui-advanced-search-wrapper ccui-clearfix">
        <el-search
          ref="elSearch"
          width="460px"
          :formProp="formData"
          @search="search"
          :isShow="true"
          :selectClear="true"
          :isShowSearch="false"
          class="ccui-highsearch no-print"
        >
          <template slot="search">
            <el-input
              v-model.trim="formData.matcateryCode"
              clearable
              searchLabel="设备物资编码"
              placeholder="请输入设备物资编码模糊查询"
            ></el-input>
          </template>
          <el-select
            class="ccui-form-longInput"
            v-model="formData.matcateryCode"
            searchLabel="设备物资编码"
            placeholder="请选择设备物资编码查询"
            slot="searchItem1"
            clearable
          >
            <el-option
              v-for="item in matcateryCodeList"
              :key="item.matcateryCode"
              :label="item.matcateryName"
              :value="item.matcateryCode"
            >
            </el-option>
          </el-select>
          <el-input
            v-model.trim="formData.supName"
            clearable
            searchLabel="供应商名称"
            placeholder="请输入供应商名称模糊查询"
            slot="searchItem2"
          ></el-input>
          <el-select
            class="ccui-form-longInput"
            v-model="formData.level"
            searchLabel="供应商等级"
            placeholder="请选择供应商等级查询"
            slot="searchItem3"
            clearable
          >
            <el-option
              v-for="item in levelList"
              :key="item.dicKey"
              :label="item.dicValue"
              :value="item.dicKey"
            >
            </el-option>
          </el-select>
          <el-input
            v-model.trim="formData.scope"
            clearable
            searchLabel="经营范围"
            placeholder="请输入经营范围模糊查询"
            slot="searchItem4"
          ></el-input>
          <el-select
            class="ccui-form-longInput"
            v-model="formData.supType"
            searchLabel="供应商类型"
            placeholder="请选择供应商类型查询"
            slot="searchItem5"
            clearable
          >
            <el-option
              v-for="item in supTypeList"
              :key="item.dicKey"
              :label="item.dicValue"
              :value="item.dicKey"
            >
            </el-option>
          </el-select>
          <el-select
            class="ccui-form-longInput"
            v-model="formData.locationCode"
            searchLabel="所在区域"
            placeholder="请选择所在区域查询"
            slot="searchItem6"
            clearable
            @change="changeLocationCode(formData.locationCode, 'locationCode')"
          >
            <el-option
              v-for="item in locationCodeList"
              :key="item.addressCode"
              :label="item.addressName"
              :value="item.addressCode"
            >
            </el-option>
          </el-select>
          <el-select
            class="ccui-form-longInput"
            v-model="formData.provinceCode"
            searchLabel="所在省份"
            placeholder="请选择所在省份查询"
            slot="searchItem7"
            clearable
            @change="changeLocationCode(formData.provinceCode, 'provinceCode')"
          >
            <el-option
              v-for="item in provinceCodeList"
              :key="item.addressCode"
              :label="item.addressName"
              :value="item.addressCode"
            >
            </el-option>
          </el-select>
          <el-select
            class="ccui-form-longInput"
            v-model="formData.cityCode"
            searchLabel="所在城市"
            placeholder="请选择所在城市查询"
            slot="searchItem8"
            clearable
            @change="changeLocationCode(formData.cityCode, 'cityCode')"
          >
            <el-option
              v-for="item in cityCodeList"
              :key="item.addressCode"
              :label="item.addressName"
              :value="item.addressCode"
            >
            </el-option>
          </el-select>
          <el-select
            class="ccui-form-longInput"
            v-model="formData.countyCode"
            searchLabel="所在区县"
            placeholder="请选择所在区县查询"
            slot="searchItem9"
            clearable
          >
            <el-option
              v-for="item in countyCodeList"
              :key="item.addressCode"
              :label="item.addressName"
              :value="item.addressCode"
            >
            </el-option>
          </el-select>
        </el-search>
      </div>
      <!--高级搜索End-->
      <!--table表格区域Begin-->
      <div class="ccui-multifunctional-table-wrapper">
        <listBaseTable
          :tableName="tableName"
          :showCheckBox="false"
          :showOp="false"
          :data="tableData"
          :cellStyle="cellStyle"
          :pageNo.sync="pageNo"
          :pageSize.sync="pageSize"
          :pageTotal="pageTotal"
          :fixedTableThead="fixedTableThead"
          :unfixedTableThead="unfixedTableThead"
          border
          @handleList="handleList"
          @select-all="handleCheckAllChange"
          @select="handleCheckChange"
          @selection-change="handleSelectionChange"
        >
          <!--列表中的插槽Begin-->
          <template slot="title" slot-scope="{ row }">
            <el-button
              class="column-btn-ellipsis"
              size="mini"
              type="text"
              @click="check(row)"
            >
              {{ row[title] }}
            </el-button>
          </template>
          <!--列表中的插槽End-->
        </listBaseTable>
      </div>
      <!--table表格区域End-->
    </div>
  </div>
</template>

<script>
import {
  qryAddressRegion, // 查询大区接口
  qryAddressByCodeRegion, // 查询大区下的省市县接口
  qryMatcateryTreeList, // 查询物资编码接口
  listDictByDJCode, // 查询供应商级别
  listDictByCode // 查询供应商类型接口
} from "@/app/shop/api/shopping";
import { mixinListCommon } from "@/mixins/mixin-common/mixin-list";
import { commonTableWidth } from "@/setting/setting";
import baseBreadCrumb from "@/app/shop/components/baseBreadCrumb.vue";
import { announcementPageSource } from "@/setting/setting";
// import moment from "moment";
export default {
  name: "list",
  mixins: [mixinListCommon],
  components: {
    baseBreadCrumb
  },
  activated() {
    this.getNoticeList();
  },
  deactivated() {
    this.initData();
  },
  props: {
    currBreadCrumb: {
      type: Array,
      default: () => {
        return [];
      }
    },
    callInterface: {
      type: Function
    },
    rowsField: {
      type: String,
      default: "rows"
    },
    source: {
      //默认是通知公告
      type: String,
      default: announcementPageSource.notice
    },
    title: {
      type: String,
      default: "title"
    }
  },
  data() {
    return {
      tableName: this.tableList.viewMoreList, // 默认的tableName 工程中唯一
      isSelection: false,
      formData: {
        level: ""
      },
      formDataSearch: {},
      tableData: [],
      unfixedTableTheadAll: [],
      fixedTableThead: [],
      unfixedTableThead: Object.freeze([
        {
          label: "序号",
          prop: "id",
          type: "index",
          width: commonTableWidth.serialNoWidth,
          checked: true
        },
        {
          label: "供应商名称",
          prop: "supName",
          checked: true,
          width: 300
          // slot: "title"
        },
        {
          label: "供应商类型",
          prop: "supTypeName",
          checked: true
          // width: 500,
        },
        {
          label: "产品目录",
          prop: "prodInfos",
          checked: true
          // width: 500,
        },
        {
          label: "所在区域",
          prop: "locationPlace",
          checked: true,
          width: 150
        },
        {
          label: "联系人",
          prop: "contactName",
          checked: true
          // width: 500,
        },
        {
          label: "联系人固话",
          prop: "contactTel",
          checked: true
          // width: 500,
        },
        {
          label: "联系人手机",
          prop: "contactMobile",
          checked: true
          // width: 500,
        }
      ]),
      pageNo: 1,
      pageSize: 10,
      pageTotal: 0,
      otherParams: {
        appId: 100125,
        module: 1,
        pageState: 2
      },
      matcateryCodeList: [], //设备物资编码集合
      levelList: [], //供应商级别集合
      supTypeList: [], //供应商类型集合
      locationCodeList: [], // 所在区域集合
      provinceCodeList: [], // 所在省份集合
      cityCodeList: [], // 所在城市集合
      countyCodeList: [] // 所在区县集合
    };
  },
  created() {
    this.init();
  },
  methods: {
    async init() {
      // 查询物资编码接口
      const data = (await qryMatcateryTreeList({ parentMatcateryCode: "00" }))
        .data.data;
      this.matcateryCodeList = data;
      // 查询供应商级别
      const levelData = (
        await listDictByDJCode({ isShowPageLoading: true, code: "SUP_SUPTYPE" })
      ).data.data;
      this.levelList = levelData;
      // this.levelList.unshift({
      //   value: "-1",
      //   suptypeQualName: levelData[0].companyName
      // });
      // 查询供应商类型
      const supData = (await listDictByCode({ code: "SUP_TYPE" })).data.data;
      this.supTypeList = supData;
      // 查询大区
      const data1 = (await qryAddressRegion({})).data.data;
      this.locationCodeList = data1;
    },
    // 大区选择后
    async changeLocationCode(val, type) {
      if (type == "locationCode") {
        // 大区改变 清空后面的内容
        this.$set(this.formData, "provinceCode", "");
        this.$set(this.formData, "cityCode", "");
        this.$set(this.formData, "countyCode", "");
      } else if (type == "provinceCode") {
        this.$set(this.formData, "cityCode", "");
        this.$set(this.formData, "countyCode", "");
      } else if (type == "cityCode") {
        this.$set(this.formData, "countyCode", "");
      }
      qryAddressByCodeRegion({ addressCode: val }).then(res => {
        console.log(res, "===444555===");
        if (type == "locationCode") {
          this.provinceCodeList = res.data.data;
        } else if (type == "provinceCode") {
          this.cityCodeList = res.data.data;
        } else if (type == "cityCode") {
          this.countyCodeList = res.data.data;
        }
      });
    },
    qryAddressByCodeRegion(addressCode) {
      qryAddressByCodeRegion({ addressCode });
    },
    initData() {
      this.pageNo = 1;
      this.pageSize = 10;
      this.pageTotal = 0;
      this.formData = {};
      this.formDataSearch = {};
      this.tableName = this.tableList.viewMoreList;
    },
    handleList() {
      // 分页操作列表
      this.getNoticeList();
    },
    getNoticeList() {
      let param = {
        pageNo: this.pageNo,
        pageSize: this.pageSize,
        isShowPageLoading: true
      };
      if (
        this.formDataSearch.publishTime &&
        this.formDataSearch.publishTime.length !== 0
      ) {
        this.formDataSearch.publishStartTime = this.formDataSearch.publishTime[0];
        this.formDataSearch.publishEndTime = this.formDataSearch.publishTime[1];
      }
      // 集采成果
      if (this.source === announcementPageSource.JCCG) {
        param.searchNoticeType = "100068JCCG";
      }
      // 集采方案
      if (this.source === announcementPageSource.JGFA) {
        param.searchNoticeType = "100068JGFA";
      }
      // 集采框架协议
      if (this.source === announcementPageSource.JCKJXY) {
        param.searchNoticeType = "100068JCKJXY";
      }
      // 物资集采目录
      if (this.source === announcementPageSource.WZJCML) {
        param.searchNoticeType = "100068WZJCML";
      }
      // 集采专家成员名单
      if (this.source === announcementPageSource.JCZJCYMD) {
        param.searchNoticeType = "100068JCZJCYMD";
      }
      // 采购管理制度
      if (this.source === announcementPageSource.CGGLZD) {
        param.searchNoticeType = "100068CGGLZD";
      }
      // 示范文本
      if (this.source === announcementPageSource.SFWB) {
        param.searchNoticeType = "100068SFWB";
      }
      // 内贸企业信息
      if (this.source === announcementPageSource.NMQYXX) {
        param.searchNoticeType = "100068NMQYXX";
      }
      // 获奖情况
      if (this.source === announcementPageSource.HJQK) {
        param.searchNoticeType = "100068HJQK";
      }
      // 湖北供应商推荐
      if (this.source === announcementPageSource.supplierRecommend) {
        this.otherParams.textType = "100068JCCG";
      }
      // 海外集采价格专区
      if (this.source === announcementPageSource.overseasZone) {
        // 待定  暂时先传湖北供应商推荐的
        this.otherParams.textType = 3;
      }
      Object.assign(param, this.formDataSearch);
      this.$delete(param, "publishTime");
      this.callInterface(param).then(res => {
        if (res.data.code === "0") {
          this.tableData = res.data.data.rows;
          this.pageTotal = res.data.data.recordsTotal;
        }
      });
    },
    search(searchData) {
      this.pageNo = 1;
      this.formDataSearch = searchData;
      this.getNoticeList();
    },
    //查看
    check(row) {
      // 工作动态和通知公告
      this.$router.push({
        path: "/announcementDetail",
        query: {
          id: row.noticeInfoId,
          source: this.source
        }
      });
    },
    cellStyle({ row, column, rowIndex, columnIndex }) {
      // 判断高亮行
      return { color: "#0089EF", cursor: "pointer" };
    },
    handleCheckAllChange(arr) {
      this.isSelection = arr.length !== 0;
    },
    handleCheckChange(arr) {
      this.isSelection = arr.length !== 0;
    },
    handleSelectionChange(arr) {
      this.isSelection = arr.length !== 0;
    }
  }
};
</script>

<style scoped lang="scss">
/deep/ .el-form-item__content {
  width: 149px;
}
/deep/ .el-search .ccui-search-wrapper {
  display: none !important;
}
</style>
